import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList, Inject, forwardRef, ElementRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import { AmazingTimePickerService } from 'amazing-time-picker';
import * as _ from "lodash";

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as util from '../../util/index'

//components
import {SpecialEventFrequencyDropdownComponent} from '../../components/DomainData/SpecialEventFrequencyDropdown.component';
import {MasterDeliveryRouteDropdownComponent} from '../../components/DomainData/MasterDeliveryRouteDropdown.component';
import {MonthDropdownComponent} from '../../components/DomainData/MonthDropdown.component';
import {OrderMethodDropdownComponent} from '../../components/DomainData/OrderMethodDropdown.component';
import {CallFrequencyDropdownComponent} from '../../components/DomainData/CallFrequencyDropdown.component';
import {DistributionModeDropdownComponent} from '../../components/DomainData/DistributionModeDropdown.component';
import {EmployeesAutoCompleteComponent} from '../../components/Employees/EmployeesAutoComplete.component';
import {DayOfWeekMultiSelectComponent} from '../../components/DomainData/DayOfWeekMultiSelect.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';
import { BaseRequestComponent }         from '../../baseclasses/BaseRequest.component';

import * as enums from '../../enums/index'
import * as serv from '../../services/index'
import { OrderMethodEnum, RequestTypeEnum } from '../../enums/index';
import { RequestType } from '../../entities/index';
import { YesNoDropdownComponent } from '../DomainData/YesNoDropdown.component';
import { SalesOfficeDropdownComponent } from '../DomainData/SalesOfficeDropdown.component';

@Component({
  selector: 'my-salesanddeliverydetails',
  templateUrl: './SalesAndDeliveryDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => SalesAndDeliveryDetailsComponent)}]
})
export class SalesAndDeliveryDetailsComponent extends BaseControlGroupComponent {

    salesAndDeliveryDetailsForm: FormGroup;
    salesAndDeliveryInfo: ent.SalesAndDeliveryInfo = new ent.SalesAndDeliveryInfo();

    businessTypeID: number = enums.BusinessTypeEnum.DSD;

    @ViewChild(SpecialEventFrequencyDropdownComponent) public specialEventDropdown: SpecialEventFrequencyDropdownComponent;
    @ViewChild(MasterDeliveryRouteDropdownComponent) public masterDeliveryRouteDropdown: MasterDeliveryRouteDropdownComponent;
    @ViewChild(OrderMethodDropdownComponent) public orderMethodDropdown: OrderMethodDropdownComponent;
    @ViewChildren(MonthDropdownComponent) monthDropdowns: QueryList<MonthDropdownComponent>;
    @ViewChild(CallFrequencyDropdownComponent) public callFrequencyDropdown: CallFrequencyDropdownComponent;
    @ViewChild(DistributionModeDropdownComponent) public distributionModeDropdown: DistributionModeDropdownComponent;
    @ViewChildren(DayOfWeekMultiSelectComponent) dayOfWeekMultiSelectComponents: QueryList<DayOfWeekMultiSelectComponent>;
    @ViewChildren(EmployeesAutoCompleteComponent) employeesAutoCompleteComponents: QueryList<EmployeesAutoCompleteComponent>;
    @ViewChild(YesNoDropdownComponent) public faceToFaceVisitPlanDropdownComponent: YesNoDropdownComponent;
    @ViewChild(SalesOfficeDropdownComponent) public salesOfficeDropdownComponent: SalesOfficeDropdownComponent;
    @ViewChild('goodsReceivingHoursStart') goodsReceivingHoursStart: ElementRef;
    @ViewChild('goodsReceivingHoursEnd') goodsReceivingHoursEnd: ElementRef;

    @Input() public salesRouteLabel: boolean;

    @Input() public showMasterRoute: boolean;
    @Input() public showMasterRouteSequence: boolean;
    @Input() public showSpecialEventCustomer: boolean;
    @Input() public showSpecialEventType: boolean;
    @Input() public showSpecialEventFrequency: boolean;
    @Input() public showSeasonalOrderer: boolean;
    @Input() public showSeasonalStartMonth: boolean;
    @Input() public showSeasonalEndMonth: boolean;
    @Input() public showSalesRoute: boolean;
    @Input() public showServiceArea: boolean;
    @Input() public showDelayBetweenOrderAndDelivery: boolean;
    @Input() public showGoodsReceivingHours: boolean;
    @Input() public showOrderMethod: boolean;
    @Input() public setOrderMethodToDefaultValue: boolean;
    @Input() public showFirstCallDate: boolean;
    @Input() public showCallFrequency: boolean;
    @Input() public showMerchLevel: boolean;
    @Input() public showMerchPercentage: boolean;
    @Input() public showDistributionMode: boolean;
    @Input() public showPalletType: boolean;
    @Input() public showTimeProfile: boolean;
    @Input() public showFirstDeliveryDate: boolean;
    @Input() public showDifferentDeliveryPoints: boolean;
    @Input() public showDeliveryPlant: boolean;
    @Input() public showCrossDockSalesOffice: boolean;
    @Input() public showDeliveryDays: boolean;
    @Input() public showCallDays: boolean;
    @Input() public showZRPartnerEmployee: boolean;
    @Input() public showExistingZJPartnerEmployee: boolean;
    @Input() public showExistingZNPartnerEmployee: boolean;
    @Input() public showZJPartnerEmployee: boolean;
    @Input() public showZNPartnerEmployee: boolean;
    @Input() public showZKPartnerEmployee: boolean;
    @Input() public showDeleteZJPartner: boolean;
    @Input() public showDeleteZNPartner: boolean;
    @Input() public showFaceToFaceVisitPlan: boolean;

    @Input() public requireMasterRoute: boolean;
    @Input() public requireMasterRouteSequence: boolean;
    @Input() public requireSalesRoute: boolean;
    @Input() public requireServiceArea: boolean;
    @Input() public requireDelayBetweenOrderAndDelivery: boolean;
    @Input() public requireGoodsReceivingHours: boolean;
    @Input() public requireOrderMethod: boolean;
    @Input() public requireMerchLevel: boolean;
    @Input() public requireMerchPercentage: boolean;
    @Input() public requirePalletType: boolean;
    @Input() public requireTimeProfile: boolean;
    @Input() public requireFirstCallDate: boolean;
    @Input() public requireCallFrequency: boolean;
    @Input() public requireDistributionMode: boolean;
    @Input() public requireFirstDeliveryDate: boolean;
    @Input() public requireZRPartnerEmployee: boolean;
    @Input() public requireZJPartnerEmployee: boolean;
    //@Input() public requireZNPartnerEmployee: boolean;
    @Input() public requireZKPartnerEmployee: boolean;
    @Input() requestTypeID: number;
    @Input() distributionChannel: string;

    public seasonalStartMonthDropdown: MonthDropdownComponent;
    public seasonalEndMonthDropdown: MonthDropdownComponent;

    selectedStartTime: string;
    selectedEndTime: string;

    public callDaysDayOfWeekMultiSelectComponent: DayOfWeekMultiSelectComponent;
    public deliveryDaysDayOfWeekMultiSelectComponent: DayOfWeekMultiSelectComponent;


    zrPartnerEmployeesAutoCompleteComponent: EmployeesAutoCompleteComponent;
    zjPartnerEmployeesAutoCompleteComponent: EmployeesAutoCompleteComponent;
    znPartnerEmployeesAutoCompleteComponent: EmployeesAutoCompleteComponent;
    zkPartnerEmployeesAutoCompleteComponent: EmployeesAutoCompleteComponent;

    selectedCrossDock: ent.SalesOffice;
    salesOffice: ent.SalesOffice;
    primaryGroupOverride: ent.PrimaryGroupOverride;

    existingZJPartnerEmployee: string;
    existingZNPartnerEmployee: string;

    setRequestInfo(request: ent.Request){
        this.salesAndDeliveryInfo = request.SalesAndDeliveryInfo;

        if (this.salesAndDeliveryInfo.ZRPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZRPartnerEmployeeID = Constants._NONE};
        if (this.salesAndDeliveryInfo.ZJPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZJPartnerEmployeeID = Constants._NONE};
        if (this.salesAndDeliveryInfo.ZNPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZNPartnerEmployeeID = Constants._NONE};
        if (this.salesAndDeliveryInfo.ZKPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZKPartnerEmployeeID = Constants._NONE};

        if (!this.salesAndDeliveryInfo.CrossDockSalesOffice){
            this.salesAndDeliveryInfo.CrossDockSalesOffice = new ent.SalesOffice();
        }

        if (request.RequestDays){
            if (this.callDaysDayOfWeekMultiSelectComponent){
                this.callDaysDayOfWeekMultiSelectComponent.selectedIDs = [];
                for (var requestDay of request.RequestDays.filter(x=>x.DayTypeID == enums.DayType.Call)){
                    this.callDaysDayOfWeekMultiSelectComponent.selectedIDs = [...this.callDaysDayOfWeekMultiSelectComponent.selectedIDs, requestDay.DayOfWeekID];
                }
            }
            if (this.deliveryDaysDayOfWeekMultiSelectComponent){
                this.deliveryDaysDayOfWeekMultiSelectComponent.selectedIDs = [];
                for (var requestDay of request.RequestDays.filter(x=>x.DayTypeID == enums.DayType.Delivery)){
                    this.deliveryDaysDayOfWeekMultiSelectComponent.selectedIDs = [...this.deliveryDaysDayOfWeekMultiSelectComponent.selectedIDs, requestDay.DayOfWeekID];
                }
            }
        }

        this.setEmployeeAutoCompleteValue(this.zrPartnerEmployeesAutoCompleteComponent, this.salesAndDeliveryInfo.ZRPartnerEmployeeID);
        this.setEmployeeAutoCompleteValue(this.znPartnerEmployeesAutoCompleteComponent, this.salesAndDeliveryInfo.ZNPartnerEmployeeID);
        this.setEmployeeAutoCompleteValue(this.zjPartnerEmployeesAutoCompleteComponent, this.salesAndDeliveryInfo.ZJPartnerEmployeeID);
        this.setEmployeeAutoCompleteValue(this.zkPartnerEmployeesAutoCompleteComponent, this.salesAndDeliveryInfo.ZKPartnerEmployeeID);

        if (this.faceToFaceVisitPlanDropdownComponent){
            if (this.salesAndDeliveryInfo.FaceToFaceVisitPlan == null) {
                this.faceToFaceVisitPlanDropdownComponent.value = Constants._NONE;
            } else if (this.salesAndDeliveryInfo.FaceToFaceVisitPlan == true) {
                this.faceToFaceVisitPlanDropdownComponent.value = Constants._YES;
            } else {
                this.faceToFaceVisitPlanDropdownComponent.value = Constants._NO;
            }
        }
        if (this.requestTypeID == enums.RequestTypeEnum.SoldToCustomer) {
            this.setSalesOffice(request.SalesOffice, this.salesAndDeliveryInfo.CrossDockSalesOfficeID);
        }
    }

    setEmployeeAutoCompleteValue(component: EmployeesAutoCompleteComponent, employeeID?: number){
        if (component){
            component.employees = [];
            component.selectedEmployeeNumbers = [];


            if (employeeID){
                var filter: filters.EmployeeFilter = {EmployeeID: employeeID};
                this.employeeService.getEmployees(filter).subscribe(x=>
                {
                    if (x && x.length > 0){
                        var employee = x[0];
                        component.employeesModel = {name: employee.FullNameWithPersonnelNumber, ID: employee.ID};
                    }

                });
            }
        }
    }

    constructor(fb: FormBuilder, private atp: AmazingTimePickerService)
    {
        super();
        let group = {
            'masterRoute' : '',
            'masterRouteSequence' : '',
            'specialEventCustomer' : '',
            'specialEventFrequency' : '',
            'specialEventType' : '',
            'seasonalOrderer' : '',
            'seasonalStartMonth' : '',
            'seasonalEndMonth' : '',
            'salesRoute' : '',
            'serviceArea' : '',
            'delayBetweenOrderAndDelivery' : '',
            'hidDelayBetweenOrderAndDelivery' : '',
            // 'goodsReceivingHours' : '',
            'goodsReceivingHoursStart' : '',
            'goodsReceivingHoursEnd' : '',
            'orderMethod' : '',
            'hidOrderMethod' : '',
            'firstCallDate' : '',
            'callFrequency' : '',
            'hidCallFrequency' : '',
            'merchLevel' : '',
            'hidMerchLevel' : '',
            'merchPercentage' : '',
            'hidMerchPercentage' : '',
            'distributionMode' : '',
            'hidDistributionMode' : '',
            'palletType' : '',
            'hidPalletType' : '',
            'timeProfile' : '',
            'hidTimeProfile' : '',
            'firstDeliveryDate' : '',
            'differentDeliveryPoints' : '',
            'crossDockSalesOfficeText' : {value:'', disabled: "true"},
            'crossDockSalesOffice' : '',
            'hidCrossDockSalesOfficeID' : '',
            'zrPartnerEmployee' : '',
            'hidZRPartnerEmployee' : '',
            'existingZJPartnerEmployee' : { value: '', disabled: "true" },
            'existingZNPartnerEmployee' : { value: '', disabled: "true" },
            'zjPartnerEmployee' : '',
            'hidZJPartnerEmployee' : '',
            'deleteZJPartner' : '',
            'znPartnerEmployee' : '',
            'hidZNPartnerEmployee' : '',
            'deleteZNPartner' : '',
            'zkPartnerEmployee' : '',
            'hidZKPartnerEmployee' : '',
            'faceToFaceVisitPlan' : ''
        };

        this.salesAndDeliveryDetailsForm = fb.group(group);

    }

    getStartTime(): string{
        return util.DateUtil.ConvertJSDateToDateString(this.convertTime(this.goodsReceivingHoursStart.nativeElement.value));
    }

    getEndTime(): string{
        return util.DateUtil.ConvertJSDateToDateString(this.convertTime(this.goodsReceivingHoursEnd.nativeElement.value));
    }

    // openStartTimePicker(){
    //     const amazingTimePicker = this.atp.open();
    //     amazingTimePicker.afterClose().subscribe(time => {
    //         this.selectedStartTime = time;


    //         this.salesAndDeliveryInfo.GoodsReceivingHoursStartString = util.DateUtil.ConvertJSDateToDateString(this.convertTime(time));

    //     });
    // }

    // openEndTimePicker(){
    //     const amazingTimePicker = this.atp.open();
    //     amazingTimePicker.afterClose().subscribe(time => {
    //         this.selectedEndTime = time;


    //         this.salesAndDeliveryInfo.GoodsReceivingHoursEndString = util.DateUtil.ConvertJSDateToDateString(this.convertTime(time));

    //     });
    // }

    setDates(){
        this.salesAndDeliveryInfo.FirstCallDate = util.DateUtil.ConvertDateToJS(this.salesAndDeliveryInfo.FirstCallDate);
        this.salesAndDeliveryInfo.FirstDeliveryDate = util.DateUtil.ConvertDateToJS(this.salesAndDeliveryInfo.FirstDeliveryDate);
        this.salesAndDeliveryInfo.GoodsReceivingHoursStart = util.DateUtil.ConvertDateToJS(this.salesAndDeliveryInfo.GoodsReceivingHoursStart);
        this.salesAndDeliveryInfo.GoodsReceivingHoursEnd = util.DateUtil.ConvertDateToJS(this.salesAndDeliveryInfo.GoodsReceivingHoursEnd);

        this.salesAndDeliveryInfo.GoodsReceivingHoursStartString = util.DateUtil.ConvertJSDateToDateString(this.salesAndDeliveryInfo.GoodsReceivingHoursStart);
        this.salesAndDeliveryInfo.GoodsReceivingHoursEndString = util.DateUtil.ConvertJSDateToDateString(this.salesAndDeliveryInfo.GoodsReceivingHoursEnd);

        this.selectedStartTime = this.salesAndDeliveryInfo.GoodsReceivingHoursStartString.substr(11,8);
        this.selectedEndTime = this.salesAndDeliveryInfo.GoodsReceivingHoursEndString.substr(11,8);

        if (this.goodsReceivingHoursStart){
            this.goodsReceivingHoursStart.nativeElement.value = this.selectedStartTime;
            this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursStart.setValue(this.selectedStartTime);
          
        }
        if (this.goodsReceivingHoursEnd){
            this.goodsReceivingHoursEnd.nativeElement.value = this.selectedEndTime;
            this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursEnd.setValue(this.selectedEndTime);
        }

    }


    ngOnInit(): void {

        var filter: filters.SalesOfficeFilter = new filters.SalesOfficeFilter();

        if (this.salesAndDeliveryInfo.ZRPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZRPartnerEmployeeID = Constants._NONE};
        if (this.salesAndDeliveryInfo.ZJPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZJPartnerEmployeeID = Constants._NONE};
        if (this.salesAndDeliveryInfo.ZNPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZNPartnerEmployeeID = Constants._NONE};
        if (this.salesAndDeliveryInfo.ZKPartnerEmployeeID == null){this.salesAndDeliveryInfo.ZKPartnerEmployeeID = Constants._NONE};

        this.salesAndDeliveryInfo.CrossDockSalesOffice = new ent.SalesOffice();
        //this.salesAndDeliveryInfo.DifferentDeliveryPoints = true;

        this.setValidators();


    }

    clearValidators(){
        this.salesAndDeliveryDetailsForm.controls.delayBetweenOrderAndDelivery.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.delayBetweenOrderAndDelivery.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.hidDelayBetweenOrderAndDelivery.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.hidDelayBetweenOrderAndDelivery.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursStart.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursStart.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursEnd.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursEnd.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.firstCallDate.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.firstCallDate.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.callFrequency.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.callFrequency.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.hidCallFrequency.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.hidCallFrequency.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.merchLevel.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.merchLevel.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.hidMerchLevel.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.hidMerchLevel.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.distributionMode.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.distributionMode.updateValueAndValidity();


        this.salesAndDeliveryDetailsForm.controls.hidDistributionMode.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.hidDistributionMode.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.firstDeliveryDate.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.firstDeliveryDate.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.hidZRPartnerEmployee.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.hidZRPartnerEmployee.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.hidZKPartnerEmployee.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.hidZKPartnerEmployee.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.hidZNPartnerEmployee.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.hidZNPartnerEmployee.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.faceToFaceVisitPlan.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.faceToFaceVisitPlan.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.timeProfile.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.timeProfile.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.merchPercentage.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.merchPercentage.updateValueAndValidity();

        this.salesAndDeliveryDetailsForm.controls.masterRoute.clearValidators();
        this.salesAndDeliveryDetailsForm.controls.masterRoute.updateValueAndValidity();

    }

    setValidators(){
        if(this.requireMasterRoute) {
            this.salesAndDeliveryDetailsForm.controls['masterRoute'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls.masterRoute.updateValueAndValidity();
        }
        if(this.requireMasterRouteSequence) {
            this.salesAndDeliveryDetailsForm.controls['masterRouteSequence'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls.masterRouteSequence.updateValueAndValidity();
        }
        if(this.requireSalesRoute) {
            this.salesAndDeliveryDetailsForm.controls['salesRoute'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls.salesRoute.updateValueAndValidity();
        }
        if(this.requireServiceArea) {
            this.salesAndDeliveryDetailsForm.controls['serviceArea'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls.serviceArea.updateValueAndValidity();
        }
        if(this.requireDelayBetweenOrderAndDelivery) {
            this.salesAndDeliveryDetailsForm.controls['delayBetweenOrderAndDelivery'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidDelayBetweenOrderAndDelivery'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.delayBetweenOrderAndDelivery.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidDelayBetweenOrderAndDelivery.updateValueAndValidity();
        }
        if(this.requireGoodsReceivingHours) {
            this.salesAndDeliveryDetailsForm.controls['goodsReceivingHoursStart'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls['goodsReceivingHoursEnd'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursStart.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursEnd.updateValueAndValidity();
        }
        if(this.requireOrderMethod) {
            this.salesAndDeliveryDetailsForm.controls['orderMethod'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidOrderMethod'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.orderMethod.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidOrderMethod.updateValueAndValidity();
        }
        if(this.requireFirstCallDate) {
            this.salesAndDeliveryDetailsForm.controls['firstCallDate'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls.firstCallDate.updateValueAndValidity();
        }
        if(this.requireCallFrequency) {
            this.salesAndDeliveryDetailsForm.controls['callFrequency'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidCallFrequency'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.callFrequency.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidCallFrequency.updateValueAndValidity();
        }
        if(this.requireMerchLevel) {
            this.salesAndDeliveryDetailsForm.controls['merchLevel'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidMerchLevel'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.merchLevel.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidMerchLevel.updateValueAndValidity();
        }
        if(this.requireMerchPercentage) {
            this.salesAndDeliveryDetailsForm.controls['merchPercentage'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidMerchPercentage'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.merchPercentage.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidMerchPercentage.updateValueAndValidity();
        }
        if(this.requireDistributionMode) {
            this.salesAndDeliveryDetailsForm.controls['distributionMode'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidDistributionMode'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.distributionMode.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidDistributionMode.updateValueAndValidity();
        }
        if(this.requirePalletType) {
            this.salesAndDeliveryDetailsForm.controls['palletType'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidPalletType'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.palletType.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidPalletType.updateValueAndValidity();
        }
        if(this.requireTimeProfile) {
            this.salesAndDeliveryDetailsForm.controls['timeProfile'].setValidators(dropDownValidator);
            this.salesAndDeliveryDetailsForm.controls['hidTimeProfile'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.timeProfile.updateValueAndValidity();
            this.salesAndDeliveryDetailsForm.controls.hidTimeProfile.updateValueAndValidity();
        }
        if(this.requireFirstDeliveryDate) {
            this.salesAndDeliveryDetailsForm.controls['firstDeliveryDate'].setValidators(Validators.required);
            this.salesAndDeliveryDetailsForm.controls.firstDeliveryDate.updateValueAndValidity();
        }
        if(this.requireZRPartnerEmployee) {
            this.salesAndDeliveryDetailsForm.controls['hidZRPartnerEmployee'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.hidZRPartnerEmployee.updateValueAndValidity();
        }
        if(this.requireZJPartnerEmployee) {
            this.salesAndDeliveryDetailsForm.controls['hidZJPartnerEmployee'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.hidZJPartnerEmployee.updateValueAndValidity();
        }
        // if(this.requireZNPartnerEmployee) {
        //     this.salesAndDeliveryDetailsForm.controls['hidZNPartnerEmployee'].setValidators(hiddenDropDownValueValidator);
        //     this.salesAndDeliveryDetailsForm.controls.hidZNPartnerEmployee.updateValueAndValidity();
        // }
        if(this.requireZKPartnerEmployee) {
            this.salesAndDeliveryDetailsForm.controls['hidZKPartnerEmployee'].setValidators(hiddenDropDownValueValidator);
            this.salesAndDeliveryDetailsForm.controls.hidZKPartnerEmployee.updateValueAndValidity();
        }
    }

    ngAfterViewInit() {
        this.seasonalStartMonthDropdown = this.monthDropdowns.toArray()[0];
        this.seasonalEndMonthDropdown = this.monthDropdowns.toArray()[1];

        this.deliveryDaysDayOfWeekMultiSelectComponent = this.dayOfWeekMultiSelectComponents.toArray()[0];
        this.callDaysDayOfWeekMultiSelectComponent = this.dayOfWeekMultiSelectComponents.toArray()[1];

        this.zrPartnerEmployeesAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[0];
        this.zjPartnerEmployeesAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[1];
        this.znPartnerEmployeesAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[2];
        this.zkPartnerEmployeesAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[3];

        this.setDefaultGoodsReceivingHours();
    }

    setDefaultGoodsReceivingHours() {
        
        switch (this.requestTypeID)
        {
            case enums.RequestTypeEnum.VisitPlanUpdate:
                break;
            default:
                if (!this.salesAndDeliveryInfo.GoodsReceivingHoursStart && !this.salesAndDeliveryInfo.GoodsReceivingHoursEnd){
                    this.goodsReceivingHoursStart.nativeElement.value = Constants._DEFAULT_GOODS_RECEIVING_HOURS_START;
                    this.goodsReceivingHoursEnd.nativeElement.value = Constants._DEFAULT_GOODS_RECEIVING_HOURS_END;
          
                    this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursStart.setValue(Constants._DEFAULT_GOODS_RECEIVING_HOURS_START);
                    this.salesAndDeliveryDetailsForm.controls.goodsReceivingHoursEnd.setValue(Constants._DEFAULT_GOODS_RECEIVING_HOURS_END);
                  }
                break;
        }
    }

    showDifferentDeliveryPointsChange(event: any){

        this.salesAndDeliveryInfo.CrossDockSalesOffice = new ent.SalesOffice();
        this.salesAndDeliveryInfo.CrossDockSalesOfficeID = null;
        if (event){
            this.salesAndDeliveryInfo.CrossDockSalesOffice = this.selectedCrossDock;
            this.salesAndDeliveryInfo.CrossDockSalesOfficeID = this.selectedCrossDock.ID;
        }
    }

    setPrimaryGroupOverride(primaryGroupOverride: ent.PrimaryGroupOverride){
        this.primaryGroupOverride = primaryGroupOverride;

        if (this.primaryGroupOverride && this.primaryGroupOverride.ZNPartnerRequired){
            this.salesAndDeliveryDetailsForm.controls['hidZNPartnerEmployee'].setValidators(hiddenDropDownValueValidator);
        }
        else {
            this.salesAndDeliveryDetailsForm.controls['hidZNPartnerEmployee'].clearValidators();
        }
        this.salesAndDeliveryDetailsForm.controls.hidZNPartnerEmployee.updateValueAndValidity();
        
    }

    setCrossDock(crossDock: ent.SalesOffice){
        this.selectedCrossDock = crossDock;

        this.salesAndDeliveryInfo.CrossDockSalesOffice = new ent.SalesOffice();
        this.salesAndDeliveryInfo.CrossDockSalesOfficeID = null;
        if (this.salesAndDeliveryInfo.DifferentDeliveryPoints){
            this.salesAndDeliveryInfo.CrossDockSalesOffice = this.selectedCrossDock;
            this.salesAndDeliveryInfo.CrossDockSalesOfficeID = this.selectedCrossDock.ID;
        }
    }

    autoSelectAndDisableDeliveryPlant() {
        if (!this.salesOffice) return false;
        return this.salesOffice.CrossDockOverride === false && this.salesOffice.CrossDockSalesOfficeID;
    }
    

    setSalesOffice(salesOffice: ent.SalesOffice, selectedSalesOfficeID: number){
      this.salesOffice = salesOffice;

      this.masterDeliveryRouteDropdown.loadOnDemand(salesOffice.Number, this.distributionChannel);
      
      this.domainDataService.getSalesOffices({IncludeInactive: false}).subscribe(x=> {
            this.salesOfficeDropdownComponent.salesOffices = x;
            var newSalesOffices: ent.SalesOffice[] = [];
            
            
            this.salesOfficeDropdownComponent.selectItems = [];
            if (this.autoSelectAndDisableDeliveryPlant()) {
                newSalesOffices = this.salesOfficeDropdownComponent.salesOffices.filter(x=>x.ID == this.salesOffice.CrossDockSalesOfficeID);
                if (newSalesOffices.length == 1){
                    var so = newSalesOffices[0];
                    this.salesOfficeDropdownComponent.selectItems.push({label:so.FullName, value:so.ID})
                    this.salesOfficeDropdownComponent.value = so.ID;
                    this.salesAndDeliveryInfo.CrossDockSalesOfficeID = so.ID;
                }
            }
            else {
                this.salesAndDeliveryInfo.CrossDockSalesOfficeID = null;
                for (var so of this.salesOfficeDropdownComponent.salesOffices){
                    if (so.ID === this.salesOffice.ID || so.ID === this.salesOffice.CrossDockSalesOfficeID) {
                        newSalesOffices.push(so);
                    }
                }
                this.salesOfficeDropdownComponent.selectItems.push({label:"", value:Constants._NONE});
                newSalesOffices.forEach(y=> this.salesOfficeDropdownComponent.selectItems.push({label:y.FullName, value:y.ID}));
                if (selectedSalesOfficeID) {
                    this.salesOfficeDropdownComponent.value = selectedSalesOfficeID;
                }
            }
    
            if (this.hideCrossDockSalesOffice()){
                this.salesAndDeliveryDetailsForm.controls.crossDockSalesOffice.clearValidators();
                this.salesAndDeliveryDetailsForm.controls.crossDockSalesOffice.updateValueAndValidity();
        
                this.salesAndDeliveryDetailsForm.controls.hidCrossDockSalesOfficeID.clearValidators();
                this.salesAndDeliveryDetailsForm.controls.hidCrossDockSalesOfficeID.updateValueAndValidity();
            }
            else {
                this.salesAndDeliveryDetailsForm.controls.crossDockSalesOffice.setValidators(dropDownValidator);
                this.salesAndDeliveryDetailsForm.controls.hidCrossDockSalesOfficeID.setValidators(hiddenDropDownValueValidator);
                this.salesAndDeliveryDetailsForm.controls.crossDockSalesOffice.updateValueAndValidity();
                this.salesAndDeliveryDetailsForm.controls.hidCrossDockSalesOfficeID.updateValueAndValidity();
            }
        }); 
    }

    hideCrossDockSalesOffice() : boolean {
      if (!this.showCrossDockSalesOffice){
        return true;
      }
      if (!this.salesOffice){
        return true;
      }
      return !this.salesOffice.CrossDockSalesOfficeID || this.salesOffice.CrossDockSalesOfficeID <= 0;
    }

    setCustomerType(customerTypeID: number) {
        
        if (customerTypeID == enums.CustomerTypeEnum.FullService){
            this.distributionChannel = Constants._DISTRIBUTION_CHANNEL_FSV;
        }
        else if (customerTypeID == enums.CustomerTypeEnum.DSD){
            this.distributionChannel = Constants._DISTRIBUTION_CHANNEL_DSD;
        }
        else{
            this.distributionChannel = '';
        }

        this.masterDeliveryRouteDropdown.loadOnDemand(this.salesOffice.Number, this.distributionChannel);
    }

    //#region Drop Down Selected events
    orderMethodSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.orderMethod.errors && form.controls.hidOrderMethod.errors){
            if (form.controls.orderMethod.errors.invalid && form.controls.hidOrderMethod.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    delayBetweenOrderAndDeliverySelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.delayBetweenOrderAndDelivery.errors && form.controls.hidDelayBetweenOrderAndDelivery.errors){
            if (form.controls.delayBetweenOrderAndDelivery.errors.invalid && form.controls.hidDelayBetweenOrderAndDelivery.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    callFrequencySelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.callFrequency.errors && form.controls.hidCallFrequency.errors){
            if (form.controls.callFrequency.errors.invalid && form.controls.hidCallFrequency.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    merchLevelSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.merchLevel.errors && form.controls.hidMerchLevel.errors){
            if (form.controls.merchLevel.errors.invalid && form.controls.hidMerchLevel.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    merchPercentageSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.merchPercentage.errors && form.controls.hidMerchPercentage.errors){
            if (form.controls.merchPercentage.errors.invalid && form.controls.hidMerchPercentage.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    distributionModeSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.distributionMode.errors && form.controls.hidDistributionMode.errors){
            if (form.controls.distributionMode.errors.invalid && form.controls.hidDistributionMode.errors.invalid){
                val = false;
            }
        }
        return val;
    }
    palletTypeSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.palletType.errors && form.controls.hidPalletType.errors){
            if (form.controls.palletType.errors.invalid && form.controls.hidPalletType.errors.invalid){
                val = false;
            }
        }
        return val;
    }
    timeProfileSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.timeProfile.errors && form.controls.hidTimeProfile.errors){
            if (form.controls.timeProfile.errors.invalid && form.controls.hidTimeProfile.errors.invalid){
                val = false;
            }
        }
        return val;
    }
    crossDockSalesOfficeSelected(){
      var val = true;
      var form = this.salesAndDeliveryDetailsForm;
      if (form.controls.crossDockSalesOffice.errors && form.controls.hidCrossDockSalesOfficeID.errors){
          if (form.controls.crossDockSalesOffice.errors.invalid && form.controls.hidCrossDockSalesOfficeID.errors.invalid){
              val = false;
          }
      }
      return val;
  }
    //#endregion

    //#region Employee Drop Down Selected events
    zrPartnerEmployeeSelected(){
        var val = true;

        var form = this.salesAndDeliveryDetailsForm;
        var control = form.controls.hidZRPartnerEmployee;
        var specialEventCustomer = form.controls.specialEventCustomer;
        if (control.errors && control.errors.invalid && !specialEventCustomer.value){
            val = false;
        }

        return val;
    }

    zjPartnerEmployeeSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.hidZJPartnerEmployee.errors){
            if (form.controls.hidZJPartnerEmployee.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    znPartnerEmployeeSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.hidZNPartnerEmployee.errors){
            if (form.controls.hidZNPartnerEmployee.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    zkPartnerEmployeeSelected(){
        var val = true;
        var form = this.salesAndDeliveryDetailsForm;
        if (form.controls.hidZKPartnerEmployee.errors){
            if (form.controls.hidZKPartnerEmployee.errors.invalid){
                val = false;
            }
        }
        return val;
    }
    //#endregion

    //#region Employee Auto Complete Changed Events
    selectedZRPartnerEmployeesChanged(employeeIDs: number[]){
        if (employeeIDs && employeeIDs.length > 0){
            this.salesAndDeliveryInfo.ZRPartnerEmployeeID = employeeIDs[0];
        }
        else{
            this.salesAndDeliveryInfo.ZRPartnerEmployeeID = Constants._NONE;
        }
    }

    selectedZJPartnerEmployeesChanged(employeeIDs: number[]){
        if (employeeIDs && employeeIDs.length > 0){
            this.salesAndDeliveryInfo.ZJPartnerEmployeeID = employeeIDs[0];
        }
        else{
            this.salesAndDeliveryInfo.ZJPartnerEmployeeID = Constants._NONE;
        }
    }

    selectedZNPartnerEmployeesChanged(employeeIDs: number[]){
        if (employeeIDs && employeeIDs.length > 0){
            this.salesAndDeliveryInfo.ZNPartnerEmployeeID = employeeIDs[0];
        }
        else{
            this.salesAndDeliveryInfo.ZNPartnerEmployeeID = Constants._NONE;
        }
    }

    selectedZKPartnerEmployeesChanged(employeeIDs: number[]){
        if (employeeIDs && employeeIDs.length > 0){
            this.salesAndDeliveryInfo.ZKPartnerEmployeeID = employeeIDs[0];
        }
        else{
            this.salesAndDeliveryInfo.ZKPartnerEmployeeID = Constants._NONE;
        }
    }
    //#endregion

    //#region Drop Down Change Events
    orderMethodChange(event: any){
        this.salesAndDeliveryInfo.OrderMethodID = event;
        if (event == OrderMethodEnum.SalesRep){
            this.faceToFaceVisitPlanDropdownComponent.value = Constants._YES;
        }
    }

    specialEventFrequencyChange(event: any){
        this.salesAndDeliveryInfo.SpecialEventFrequencyID = event;
    }

    specialEventTypeChange(event: any){
        this.salesAndDeliveryInfo.SpecialEventTypeID = event;
    }

    masterDeliveryRouteChange(event: any){
        this.salesAndDeliveryInfo.MasterDeliveryRouteID = event;
    }

    callFrequencyChange(event: any){
        this.salesAndDeliveryInfo.CallFrequencyID = event;
    }

    merchLevelChange(event: any){
        this.salesAndDeliveryInfo.MerchLevelID = event;
    }

    merchPercentageChange(event: any){
        this.salesAndDeliveryInfo.MerchPercentageID = event;
    }

    distributionModeChange(event: any){
        this.salesAndDeliveryInfo.DistributionModeID = event;
    }

    palletTypeChange(event: any){
        this.salesAndDeliveryInfo.PalletTypeID = event;
    }

    timeProfileChange(event: any){
        this.salesAndDeliveryInfo.TimeProfileID = event;
    }

    crossDockSalesOfficeChange(event: any){
      this.salesAndDeliveryInfo.CrossDockSalesOfficeID = event;
    }

    seasonalStartMonthChange(event: any){
        if (event && event > Constants._NONE){
            this.salesAndDeliveryInfo.SeasonalOrderer = true;
        }
        this.salesAndDeliveryInfo.SeasonalStartMonthID = event;
    }

    seasonalEndMonthChange(event: any){
        if (event && event > Constants._NONE){
            this.salesAndDeliveryInfo.SeasonalOrderer = true;
        }
        this.salesAndDeliveryInfo.SeasonalEndMonthID = event;
    }

    disableSeasonalOrderer(): boolean {
        return this.salesAndDeliveryInfo.SeasonalStartMonthID > Constants._NONE 
            || this.salesAndDeliveryInfo.SeasonalEndMonthID > Constants._NONE;
    }

    delayBetweenOrderAndDeliveryChange(event: any){
        this.salesAndDeliveryInfo.DelayBetweenOrderAndDeliveryID = event;
    }

    faceToFaceVisitPlanChange(event: any){
        if (event == Constants._NONE){
            this.salesAndDeliveryInfo.FaceToFaceVisitPlan = null;
        }
        else if (event == Constants._YES) {
            this.salesAndDeliveryInfo.FaceToFaceVisitPlan = true;
        } else {
            this.salesAndDeliveryInfo.FaceToFaceVisitPlan = false;
        }

    }
    //#endregion

    disableFaceToFaceVisitPlan(): boolean {
        return this.salesAndDeliveryInfo.OrderMethodID == OrderMethodEnum.SalesRep;
    }

    showFaceToFaceVisitPlanRequiredValidator(): boolean {
        if (!this.requestTypeID) return false;
        if (this.requestTypeID == RequestTypeEnum.SoldToCustomer){
            if (this.businessTypeID == enums.BusinessTypeEnum.SecondaryVolume){
                return false;
            }
            return this.salesAndDeliveryInfo.FaceToFaceVisitPlan === null;
        }
        else if (this.requestTypeID == RequestTypeEnum.VisitPlanUpdate){
            return (this.salesAndDeliveryInfo.OrderMethodID > 0 && this.salesAndDeliveryInfo.FaceToFaceVisitPlan === null);
        }

    }
}